import { api } from '@/api'
import type { BankAccount } from '@/api/typings/bank-account.typing'
import type { ApiResponse } from '@/api/typings/response.typing'

// ======= Payloads =======

export interface UpdateIranianAccountPayload {
  sheba_number: string
  card_number: string
  bank_name: string
  owner_full_name: string
  national_code: string
  birth_date: string
}

export interface UpdateInternationalAccountPayload {
  iban_number: string
  bic_number: string
  bank_name: string
  owner_full_name: string
  country_id: string
  sort_code?: string
  account_number?: string
  is_pound?: boolean
}

export interface UpdateInternationalRevolutAccountPayload {
  iban_number: string
  bic_number: string
  bank_name: string
  owner_full_name: string
  country_id: string
  revolut_tag: string
}

export interface UpdateInternationalPaypalAccountPayload {
  paypal_email: string
  paypal_id?: string
  bank_name: string
  owner_full_name: string
  country_id: string
}
export interface UpdateInternationalWiseAccountPayload {
  iban_number: string
  bic_number: string
  bank_name: string
  owner_full_name: string
  country_id: string
  wise_tag?: string
}

// ======= Update Iranian Accounts =======

export function updateIranianAccountAction(
  userId: string,
  accountId: string,
  payload: UpdateIranianAccountPayload
): Promise<ApiResponse<BankAccount>> {
  return api.put<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/iranian/${accountId}`, {
    ...payload,
  })
}

export function updateIranianSrcAccountAction(
  userId: string,
  accountId: string,
  payload: UpdateIranianAccountPayload
): Promise<ApiResponse<BankAccount>> {
  return api.put<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/iranian-src/${accountId}`, {
    ...payload,
  })
}

// ======= Update International Accounts =======

export function updateInternationalAccountAction(
  userId: string,
  accountId: string,
  payload: UpdateInternationalAccountPayload
): Promise<ApiResponse<BankAccount>> {
  return api.put<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/international/${accountId}`, {
    ...payload,
  })
}

export function updateInternationalRevolutAccountAction(
  userId: string,
  accountId: string,
  payload: UpdateInternationalRevolutAccountPayload
): Promise<ApiResponse<BankAccount>> {
  return api.put<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/international-revolut/${accountId}`, {
    ...payload,
  })
}

export function updateInternationalPaypalAccountAction(
  userId: string,
  accountId: string,
  payload: UpdateInternationalPaypalAccountPayload
): Promise<ApiResponse<BankAccount>> {
  return api.put<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/international-paypal/${accountId}`, { ...payload })
}
export function updateInternationalWiseAccountAction(
  userId: string,
  accountId: string,
  payload: UpdateInternationalWiseAccountPayload
): Promise<ApiResponse<BankAccount>> {
  return api.v2.put<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/international-wise/${accountId}`, {
    ...payload,
  })
}
